import React from 'react';

import { Modal } from 'src/components/common';
import { InvitePeoPayrollProviderByCVStaffModalForm } from 'src/components/peoPayrollProvider';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

export const InvitePeoPayrollProviderByCVStaffModal: React.FC = () => {
  const { closeModal, switchClosability, isOpen } = useModal(
    ModalId.InvitePeoPayrollProviderByCVStaffModal,
  );

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Invite PEO Payroll Providers"
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
      }}
    >
      <InvitePeoPayrollProviderByCVStaffModalForm
        closeModal={onCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
